import axios from 'axios';
import Swal from 'sweetalert2';
import {obtenerDominio} from './util/dominios';
import { validateVersion } from './plugins/versions';
import { attemptLogin } from './plugins/sessionLogin';
import store from "./store/store";
import router from "./main";
const $http = axios.create({
    baseURL: obtenerDominio(),
    headers: {
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept',
        'Authorization': '',
        'Cache-Control': 'no-cache,no-store',
        'Pragma': 'no-cache',
        'Expires': '0'
    },
});
const controller = new AbortController();
const CancelToken = axios.CancelToken;

/**
 * Interceptor para agregar token a la petición Http
 */
$http.interceptors.request.use(config => {

    const token = localStorage.getItem('token');

    const urlsAllow = [
        '/auth/login',
        '/auth/logout',
        '/auth/reset-password',
        '/auth/validate-token',
        '/auth/change-forgotten-password',
        '/auth/verify-current-user/is-human',
        '/auth/fecha-hora',
        '/auth/microsoft.online/callback'
    ]

    const authMIicrosoft = /^\/auth\/microsoft\.online\/verified-nit-company\/\d+$/;

    if (!urlsAllow.includes(config.url) && store.state.autenticacion.closeSession && !authMIicrosoft.test(config.url)){
        const source = CancelToken.source();
        config.cancelToken = source.token;
        controller.abort();
        return Promise.reject({response : {status: 401 ,message: 'No token found in local storage'}});
    }

    if (token) {
        config.headers.Authorization = token;
    }

    return config;
});

/**
 * Interceptor para capturar la respuesta y token refrescado
 */
$http.interceptors.response.use((res) => {

    store.commit("autenticacion/setStatusResponse", res.status, { root: true })
    let token;
    localStorage.removeItem('token');

    if (res.data.token) {
        token = 'Bearer ' + res.data.token;
        localStorage.setItem('acl', JSON.stringify(res.data.data.acl));
        localStorage.setItem('cambio_clave', JSON.stringify(res.data.data.cambio_clave));
    } else {
        token = res.headers.authorization;
    }
    if(res.headers['update-version'])validateVersion(res.headers['version']);

    localStorage.setItem('token', token);

    return res;
}, async error => {

    store.commit("autenticacion/setStatusResponse", error.response.status, { root: true })
    switch (error.response.status) {
        case 401:
        case 409:
            if (router.currentRoute.path != '/login' && (error.config && error.config.url != 'users/save-time-active')){
                const originalRequest = error.config;
                await attemptLogin(originalRequest);
                let http = store.state.autenticacion.originalRequest;
                store.commit("autenticacion/clearOriginalRequest", null, { root: true });
                return $http(http);
            }
            break;
        case 403:
            localStorage.setItem('token', error.response.headers.authorization);

            await Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'No tiene permisos para realizar esta acción',
                timer: 3000,
                showConfirmButton: true
            });

            break;
        case 500:
            const token = error.response.headers.authorization ? error.response.headers.authorization : error.response.config.headers.Authorization;

            localStorage.setItem('token', token);

            await Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Error en el sistema, consulte al administrador',
                timer: 1500,
                showConfirmButton: false
            });

            break;
        default:
            localStorage.setItem('token', error.response.headers.authorization);
            break;
    }

    return Promise.reject(error.response.data, error.response, error);
});

export default $http;


